// src/store/services/addressApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const addressApi = createApi({
  reducerPath: "addressApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/address",
    prepareHeaders: (headers, { getState }) => {
      const token =
        getState()?.userSlice?.token || localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Address"],
  endpoints: (builder) => ({
    createAddress: builder.mutation({
      query: ({ ...body }) => {
        const payload = { ...body };

        // if (role === "customer") payload.userId = userId;
        // if (role === "provider") payload.userId = userId;
        return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Address"],
    }),

    updateAddress: builder.mutation({
      query: ({ userId, addressId, body }) => ({
        // const payload = {}
        url: `/${addressId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Address"],
    }),

    deleteAddress: builder.mutation({
      query: ({ userId, addressId }) => ({
        url: `/${addressId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Address"],
    }),

    getAddresses: builder.query({
      query: ({search} ={}) => {
        let url = ''
         if (search) {
          url += `&search=${search}`;
        }

        return{
        url: ``,
        method: "GET",
        // params,
        }
      },
      // providesTags: ["Address"],
    }),

    getOneAddresses: builder.query({
      query: (query = {}) => {
        const {  limit = 50, id, } = query;
        let url = `/${id}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useGetAddressesQuery,
  useGetOneAddressesQuery
} = addressApi;
